import { EventsTypeEnum } from '__generated__/types';
import { LeftOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import { dayjs } from 'common/dayjs';
import { AntButton } from 'components/ant/AntButton/AntButton';
import { AntCheckbox, AntCheckboxGroup } from 'components/ant/AntCheckbox/AntCheckbox';
import { AntSpace } from 'components/ant/AntSpace/AntSpace';
import { XText } from 'components/UI/XText/XText';
import type { Dayjs } from 'dayjs';
import { LABELS_MAP } from 'pages/CalendarPage/CalendarPage.const';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import s from './CustomHeader.module.less';

interface Props {
  date: Dayjs;
  onAddActionClick: () => void;
  filters: EventsTypeEnum[];
  onFiltersChange: (filters: EventsTypeEnum[]) => void;
  setCurrentDate: (date: Dayjs) => void;
}

const MONTHS_TRANSLATION_KEYS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const CustomHeader: FC<Props> = ({ date, onAddActionClick, onFiltersChange, filters, setCurrentDate }) => {
  const { t } = useTranslation();
  const year = date.year();

  return (
    <>
      <div className={s.container}>
        <div className={s.titleContainer}>
          <div className={s.title}>
            <XText variant="title-h1-s">
              {t(`calendar.months.${MONTHS_TRANSLATION_KEYS[date.month()]}`)} {year}
            </XText>
          </div>
          <AntSpace>
            <AntButton onClick={() => setCurrentDate(dayjs())}>{t('calendar.today')}</AntButton>
            <AntSpace className={s.changeMonthBtnCnt}>
              <AntButton
                type="default"
                icon={<LeftOutlined />}
                onClick={() => setCurrentDate(dayjs(date).subtract(1, 'month'))}
              />
              <AntButton
                type="default"
                icon={<RightOutlined />}
                onClick={() => setCurrentDate(dayjs(date).add(1, 'month'))}
              />
            </AntSpace>
            <AntButton className={s.addActionBtn} type="primary" icon={<PlusOutlined />} onClick={onAddActionClick} />
          </AntSpace>
        </div>
        <div className={s.filters}>
          <AntCheckboxGroup value={filters} onChange={(list) => onFiltersChange(list)}>
            <AntCheckbox value={EventsTypeEnum.PoLeadtimeEvent}>
              {LABELS_MAP[EventsTypeEnum.PoLeadtimeEvent](t)}
            </AntCheckbox>
            <AntCheckbox value={EventsTypeEnum.ProductionEvent} className={s.productionHolidaysCheckbox}>
              {LABELS_MAP[EventsTypeEnum.ProductionEvent](t)}
            </AntCheckbox>
            <AntCheckbox value={EventsTypeEnum.PublicHolidayEvent} className={s.publicHolidaysCheckbox}>
              {LABELS_MAP[EventsTypeEnum.PublicHolidayEvent](t)}
            </AntCheckbox>
          </AntCheckboxGroup>
        </div>
      </div>
    </>
  );
};
